export default "__VITE_ASSET__3c9654fc__"